/** テレビ表示の中心時間帯（9〜19時） */
export const TV_DISPLAY_HOUR_RANGE = [9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19];

/** 2時間刻みの開始時刻 */
export const TV_TWO_HOUR_STARTS = [9, 11, 13, 15, 17, 19];

export const TV_DAY_PARTS = [
  { key: 'morning', label: '朝', hours: [9, 10, 11] },
  { key: 'noon', label: '昼', hours: [12, 13, 14, 15] },
  { key: 'evening', label: '夕', hours: [16, 17, 18, 19] },
];

/** 凡例用サンプル（GREEN_YELLOW_RED_ONE パレットの代表値） */
export const TV_LEGEND_SAMPLES = [
  { label: '空いている', raw: 4, hint: '青〜緑系' },
  { label: 'ふつう', raw: 10, hint: '黄系' },
  { label: 'にぎわう', raw: 18, hint: '赤〜橙系' },
];

export const rawToCongestionTier = (raw) => {
  const v = Math.round(Number(raw) || 0);
  if (v <= 0) {
    return { label: 'データなし', raw: 0, tier: 'none' };
  }
  if (v <= 7) return { label: '空いている', raw: v, tier: 'low' };
  if (v <= 12) return { label: 'ふつう', raw: v, tier: 'mid' };
  if (v <= 16) return { label: 'やや多い', raw: v, tier: 'high-mid' };
  return { label: 'にぎわう', raw: v, tier: 'high' };
};

export const avgForDayPart = (hourlyMap, hours) => {
  if (!hourlyMap) return 0;
  const vals = hours.map((h) => hourlyMap[h] || 0).filter((v) => v > 0);
  if (!vals.length) return 0;
  return Math.round(vals.reduce((a, b) => a + b, 0) / vals.length);
};

export const buildDaySlots = (hourlyMap) =>
  TV_DAY_PARTS.map((part) => {
    const avg = avgForDayPart(hourlyMap, part.hours);
    const tier = rawToCongestionTier(avg);
    return {
      key: part.key,
      partLabel: part.label,
      ...tier,
    };
  });

const twoHourWindow = (startHour) => {
  if (startHour >= 19) return [18, 19];
  return [startHour, startHour + 1];
};

/** 今日の2時間刻みスロット（9,11,13,15,17,19時起点） */
export const buildTwoHourSlots = (hourlyMap) =>
  TV_TWO_HOUR_STARTS.map((start) => {
    const hours = twoHourWindow(start);
    const avg = avgForDayPart(hourlyMap, hours);
    const tier = rawToCongestionTier(avg);
    const end = hours[hours.length - 1];
    const timeLabel = start === end ? `${start}時` : `${start}〜${end}時`;
    return {
      key: `h${start}`,
      timeLabel,
      ...tier,
    };
  });

export const dailyAvgCongestion = (hourlyMap) =>
  avgForDayPart(hourlyMap, TV_DISPLAY_HOUR_RANGE);

export const findBusiestTwoHourLabel = (slots) => {
  if (!slots?.length) return null;
  let max = 0;
  let label = null;
  slots.forEach((s) => {
    if (s.raw > max) {
      max = s.raw;
      label = s.timeLabel;
    }
  });
  return label;
};

/** いちばん混む時間帯名（朝・昼・夕） */
export const findBusiestPartName = (slots) => {
  if (!slots?.length) return null;
  let max = 0;
  let part = null;
  slots.forEach((s) => {
    if (s.raw > max) {
      max = s.raw;
      part = s.partLabel || null;
    }
  });
  return part;
};

/** ピーク時刻が属する時間帯名（朝・昼・夕）— 時間別ピークと整合 */
export const findBusiestPartFromHourly = (hourlyMap) => {
  if (!hourlyMap) return null;
  let maxHour = null;
  let maxVal = 0;
  TV_DISPLAY_HOUR_RANGE.forEach((h) => {
    const v = hourlyMap[h] || 0;
    if (v > maxVal) {
      maxVal = v;
      maxHour = h;
    }
  });
  if (maxHour == null || maxVal <= 0) return null;
  const part = TV_DAY_PARTS.find((p) => p.hours.includes(maxHour));
  return part?.label || null;
};

